
import { ref } from "vue";
import { userService } from "@/service";
import { defineComponent } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ImagePreview, Dialog } from "vant";

export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();
    const detail: any = ref({});
    const getDetail = async () => {
      const { data } = await userService.userInfo({
        user_id: route.params.id,
        user_information: 1
      });
      detail.value = data.data;
    };
    getDetail();

    const handleRemove = async () => {
      try {
        await Dialog.alert({
          title: "标题",
          message: "删除后不可恢复，确认要删除该人员吗？",
          showCancelButton: true
        });
        await userService.del_house_user({ user_id: route.params.id, house_id: route.query.house_id });
        router.back();
      } catch (error) {
        console.log(error);
      }
    };

    return { detail, ImagePreview, handleRemove };
  }
});
